import React from "react";
import Trigger from "react-foundation-apps/src/trigger";
import Translate from "react-translate-component";
import { getWalletName } from "branding";
import counterpart from "counterpart";
import { Modal, Button } from "bitshares-ui-style-guide";
export default class BrowserSupportModal extends React.Component {
  _openLink() {
    let newWnd = window.open("https://www.google.com/chrome/browser/desktop/", "_blank");
    newWnd.opener = null;
  }

  render() {
    return /*#__PURE__*/React.createElement(Modal, {
      visible: this.props.visible,
      onCancel: this.props.hideModal,
      title: counterpart.translate("app_init.browser"),
      footer: [/*#__PURE__*/React.createElement(Button, {
        key: "submit",
        type: "primary",
        onClick: this.props.hideModal
      }, counterpart.translate("app_init.understand"))]
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block vertical no-overflow"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "app_init.browser_text",
      wallet_name: getWalletName()
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      className: "external-link",
      onClick: this._openLink
    }, "Google Chrome"))));
  }

}